module.exports = __webpack_public_path__ + "img/identity.2b0f5e65.png";